import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex w-full gap-10 py-3 sm:py-6 xl:gap-13',
    stickyHeader:
      'pointer-events-none invisible fixed inset-x-0 top-0 z-30 opacity-0 transition-opacity duration-150',
    container: 'flex w-full flex-col gap-4 sm:mb-5',
    header: 'flex flex-col gap-6',
    content: 'flex w-full flex-col gap-10 md:flex-row md:gap-12',
    main: 'w-full md:flex-1',
    sidebar: 'shrink-0 pt-0 max-lg:hidden md:pt-19',
    sidebarSticky: 'sticky top-25',
    sidebarMobile: 'lg:hidden'
  }
});
